import * as React from 'react';
import { Typography, Menu, MenuItem, Button } from '@mui/material';
import Link from 'components/Link';
import icon from 'images/zeek.svg';
import Zeek from 'components/Zeek';
import { useSpring, animated } from "@react-spring/web";

import bubble from 'images/chat_bubble.svg';

import { getColor } from 'utils/theme';

import { remCalc } from '../utils/theme';

const Dropdown = ({open, links, anchor, onClose, anchorOrigin, transformOrigin}) => {
	const [zeekActive, setZeekActive] = React.useState(false);
	const [menuHeight, setMenuHeight] = React.useState(0);
	const menuRef = React.useRef();
	const bubbleRef = React.useRef();
	const overrides = {
		'.MuiPopover-paper': {
			background: getColor('blue', 600),
			color: getColor('white', 100),
			boxShadow: 'none',
			borderRadius: 0,
			borderBottomRightRadius: remCalc(100),
			border: 'none',
			top: '0px !important',
			left: '0px !important',
			width: '100%',
			maxWidth: '100%',
			paddingTop: remCalc(130),
			paddingBottom: remCalc(125),
			// padding: '182px 50px 20px 50px',
		},
		'.MuiMenu-list': {
			padding: '0',
			margin: '0',
			'.MuiMenuItem-root': {
				justifyContent: 'center',
				marginBottom: '35px',
				a: {
					textDecoration: 'none',
				}
			},
			'.zeek-trigger': {
				position: 'absolute',
				width: '100%',
				transform: 'translateY(20px)',
				'.zeek-button': {
					display: 'block',
					'.zeek-trigger-chat-bubble': {
						position: 'absolute',
						opacity: 0,
						transform: 'translateX(-77%) translateY(50%)',
					},
					'.zeek-trigger-icon': {
						width: remCalc(169),
					}
				},
			}
		},
	};

	const menuItemStyle = {
		marginBottom: '16px',
	}

	if (menuRef.current && menuHeight === 0) {
		const paper = menuRef.current.querySelector('.MuiMenu-paper');
		setMenuHeight(paper.getBoundingClientRect().height);
	}

	const closeMenu = React.useCallback(onClose, [onClose]);

	React.useEffect(() => {
		if (zeekActive === true)closeMenu();
	}, [zeekActive, closeMenu]);

	const zeekSprings = {
		from: { y: 0 },
		to: [
			{ y: 0, delay: 1000 },
			{ y: -20 },
			{ y: -20, delay: 2000 },
			{ y: 0 },
		],
	}

	const [zeekAnimation, api] = useSpring((stuff) => {
		return {
			...zeekSprings,
			duration: 550,
			loop: true,
			config: {
				friction: 15,
			},
			onChange: {
				y: (value) => {
					if (value === -20 && bubbleRef.current) {
						bubbleRef.current.style.opacity = 1;
					} else if (bubbleRef.current) {
						bubbleRef.current.style.opacity = 0;
					}
				}
			},
		}
	}, []);

	if (open) {
		api.start(zeekSprings);
	} else {
		api.stop();
	}

	return (
		<>
		<Zeek className={`mobile`} active={zeekActive} setActive={setZeekActive} menuHeight={menuHeight} />
		<Menu ref={menuRef} sx={overrides} open={open} onClose={onClose} anchorEl={anchor} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin}>
			<>
			{links.map((item, index) => <MenuItem key={index} sx={menuItemStyle}><Link href={item.href} onClick={onClose}><Typography variant="mobileNav">{item.text}</Typography></Link></MenuItem>)}
			<MenuItem key={'zeek'} className="zeek-trigger">
				<animated.div style={zeekAnimation}>
					<Button variant="invisible" className="zeek-button" disableRipple={true} onClick={() => setZeekActive(true)}>
						<img ref={bubbleRef} src={bubble} className="zeek-trigger-chat-bubble" alt=""/>
						<img src={icon} className="zeek-trigger-icon" alt="Open Mission Control" />
					</Button>
				</animated.div>
			</MenuItem>
			</>
		</Menu>
		</>
	)
}

export default Dropdown;